export enum UserType {
  USER = 'USER',
  ADMIN = 'ADMIN',
  NONE = 'NONE',
}
